{% block sw_cms_section_action_select %}
    {% parent() %}

    <moorl-section-config
        v-if="moorlIsUnlocked"
        v-bind="{ section }"
    />
{% endblock %}